import React from 'react';
import { GelBoxLayout, GelButton, GelRowLayout } from '@tal-gel/components';
import { buttonStyle, paginationRow } from '../Shared/Styles';

const PaginationButtons = React.memo(({
    totalCount,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage
}) => {
    const paginationLabel = () => {
        const paginationLabelText = (((currentPage - 1) * pageSize + 1) + "-" + ((totalCount > currentPage * pageSize) ? currentPage * pageSize : totalCount) + " of " + totalCount);

        return (paginationLabelText);
    };

    const paginationButtons = () => {
        var pageNumberButtons = [];

        for (var i = 1; i <= Math.ceil(totalCount / pageSize); i++) {
            if (i === currentPage) {
                pageNumberButtons.push(<GelButton style={buttonStyle} key={i} primary small onClick={changePage.bind(this, i)} >{i}</GelButton>);
            } else {
                pageNumberButtons.push(<GelButton style={buttonStyle} key={i} secondary small onClick={changePage.bind(this, i)} >{i}</GelButton>);
            }
        }


        return (pageNumberButtons);
    };

    const changePage = (pageNum) => {
        setCurrentPage(pageNum);
    };

    const previousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const nextPage = () => {
        if (currentPage < Math.ceil(totalCount / pageSize)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const changePaginationSize = (e) => {
        setPageSize(e.target.value);
        setCurrentPage(1);
    };

    return (
        <GelRowLayout gutter="small" style={paginationRow}>
            <GelBoxLayout space="auto">
                {paginationLabel()}
                <select id="paginationDropdown" value={pageSize} onChange={changePaginationSize.bind(this)} >
                    <option value="15">15</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                </select>
                {(currentPage === 1) ? null : <GelButton style={buttonStyle} secondary small onClick={previousPage} >&lt;</GelButton>}
                {paginationButtons()}
                {(currentPage === Math.ceil(totalCount / pageSize)) ? null : <GelButton style={buttonStyle} secondary small onClick={nextPage} >&gt;</GelButton>}
            </GelBoxLayout>
        </GelRowLayout>
    );

});

export default PaginationButtons;